/**
 * What a room is called where a person reads it. RoomPlan names a room by its
 * kind, camel-cased (`livingRoom`, `diningRoom`, `kitchen`), and the room
 * keeps that name until someone renames it — so the stored name is spelled
 * out: `livingRoom` → `Living room`, `kitchen` → `Kitchen`.
 *
 * Splitting camelCase is safe only when the name HAS no spaces: a person's
 * own `Main Suite` must survive verbatim, and lower-casing its second word to
 * match the room-kind vocabulary would be rewriting their name. Pure.
 *
 * @param {string|null|undefined} name  the room's stored name
 * @returns {string|null}  null for a room with no name
 */
function roomDisplayName(name) {
  const s = String(name ?? '').trim();
  if (!s) return null;
  if (!/\s/.test(s) && /[a-z][A-Z]/.test(s)) {
    const spaced = s.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

module.exports = { roomDisplayName };
